import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { environment } from '../../../../../environments/environment';
import * as signalR from '@microsoft/signalr';
import { selectAuthToken } from '../../../auth/state/auth.selectors';
import { firstValueFrom } from 'rxjs';
import { logoutButtonClicked } from '../../../auth/state/auth.actions';
import { filter } from 'rxjs/operators';
import { AuthService } from '../../../auth/data/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class SessionHubService {
  private hubConnection!: signalR.HubConnection;
  private store = inject(Store);
  private baseUrl = environment.apiUrl;
  private authService = inject(AuthService);

  public listenForForceLogout() {
    if (this.hubConnection?.state !== signalR.HubConnectionState.Connected) {
      this.createConnection();
    }

    window.addEventListener('storage', (event) => {
      if (event.key !== 'forceLogoutFromOtherTabs') return;
      if (event.newValue === null) return;
      this.store.dispatch(logoutButtonClicked());
    });
  }

  private async createConnection() {
    const token = await firstValueFrom(
      this.store.select(selectAuthToken).pipe(filter((t) => !!t)),
    );

    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${this.baseUrl}SessionHub`, {
        accessTokenFactory: () => token!,
      })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build();

    this.hubConnection.on(
      'ForceLogout',
      async (payload: { allowedSessionId: string }) => {
        const currentSessionId = await this.authService.getSessionIdFromToken();
        if (currentSessionId !== payload.allowedSessionId) {
          console.warn('[SessionHub] ForceLogout for this session');
          this.store.dispatch(logoutButtonClicked());
        } else {
          console.log('[SessionHub] Ignored ForceLogout for current session');
        }
      },
    );

    this.startConnection();
  }

  private startConnection() {
    this.hubConnection
      .start()
      .then(() => console.log('[SessionHub] Connected'))
      .catch((err) => console.error('[SessionHub] Connection failed:', err));

    this.hubConnection.onclose((err) => {
      console.warn('[SessionHub] Connection closed:', err);
    });
  }
}
